import React, { useState, useEffect } from "react";
import { Divider, Radio } from '@nextui-org/react'
import { useSelector } from "react-redux";

import checkAccess from '../../../lib/checkAccess';
import { secureFetch } from "../../../lib/api";
import { error } from "../../../lib/userAlerts";
import endpoint from "../../../config/endpoint.json";
import { mstore } from "../../../store";
import { updateTitle } from "../../../lib/utils";

import CurrentData from "./CurrentData";
import DriverStats from "./DriverStats";
import BrokerStats from "./BrokerStats";

const OVERALL_DATA = 1;
const DRIVER_STATS = 2;
const BROKER_TRENDS = 3;

const DashBoard = () => {
    const clientId = useSelector(state => state.client?.id || mstore.getPath(["user", "company_id"]));
    const [chartType, setChartType] = useState(OVERALL_DATA);
    const [isBroker, setIsBroker] = useState(0);

    useEffect(() => {
        checkAccess(clientId);
        fetchCompanyDetails();
        updateTitle("Dashboard");
    }, [clientId]);

    const fetchCompanyDetails = async () => {
        try {
            const [ok, status, company] = await secureFetch(endpoint.getCompanyDetails);
            if (ok) {
                setIsBroker(company.is_broker);
            } else {
                error("Unable to fetch company details");
            }
        } catch (err) {
            error("Unable to fetch company details");
        }
    };

    const renderContent = () => {
        switch (chartType) {
            case OVERALL_DATA:
                return <CurrentData clientId={clientId} />;
            case DRIVER_STATS:
                return <DriverStats />;
            case BROKER_TRENDS:
                return <BrokerStats clientId={clientId} />;
            default:
                return null;
        }
    };

    return (
        <div style={{ height: "100%", width: "100%" }}>
            <Radio.Group 
                row 
                css={{ mt: '0.75rem', padding: 10 }}
                value={chartType}
            >
                <Radio
                    onChange={() => setChartType(OVERALL_DATA)}
                    value={OVERALL_DATA}
                >
                    System Snapshot
                    <Radio.Desc>The default dashboard view</Radio.Desc>
                </Radio>
                <Radio
                    onChange={() => setChartType(DRIVER_STATS)}
                    value={DRIVER_STATS}
                >
                    Driver Stats
                    <Radio.Desc>See how your company drivers are performing</Radio.Desc>
                </Radio>
                <Radio
                    disabled={!isBroker}
                    onChange={() => setChartType(BROKER_TRENDS)}
                    value={BROKER_TRENDS}
                >
                    {isBroker ? `Broker Trends` : `Broker Trends (Disabled)`}
                    <Radio.Desc>
                        {isBroker 
                            ? `See how your shipments are Fulfilled` 
                            : `Please enable the broker options in the accounts section`
                        }
                    </Radio.Desc>
                </Radio>
            </Radio.Group>

            <Divider />

            <div 
                className="w-100 pr-2" 
                style={{ height: 'calc(100vh - 220px)' }}
            >
                {renderContent()}
            </div>
        </div>
    );
};

export default DashBoard;